/****************************************************************************************
 * Copyright (c) 2023. Peter Lemke, SV-Studios                                          *
 * This File, its contents and by extension the corresponding project is property of    *
 * SV-Studios and may not be used without explicit permission to do so.                 *
 *                                                                                      *
 * management@sv-studios.net                                                            *
 ****************************************************************************************/

import { createSlice } from "@reduxjs/toolkit";

const flagsSlice = createSlice({
  name: "flags",
  initialState: {
    available: [],
    enabled: {},
    showDialog: false,
  },
  reducers: {
    toggleFlag: (state, action) => {
      state.enabled[action.payload] = !state.enabled[action.payload];
    },
    initializeFlags: (state, action) => {
      state.available = action.payload;
    },
    setShowDialog: (state, action) => {
      state.showDialog = action.payload;
    },
  },
});

export const flagsAction = flagsSlice.actions;

export default flagsSlice;
